import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';

function ProjectDetailContainer() {
    const settingsMedia = {
        dot: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dot: false,
                    arrow: false,
                    rows: 4,
                }
            }
        ]
    }

    return(
        <article className="layout-contents-container page-projects">
            <button type="button" className="btn-back">Back</button>

            <header className="project-detail">
                <h1 className="title">Domus Korea N.04 Borderless Boundary</h1>
                <dl className="description">
                    <div className="description-item">
                        <dt>Year.</dt>
                        <dd>2019</dd>
                    </div>
                    <div className="description-item">
                        <dt>Type.</dt>
                        <dd>Publication</dd>
                    </div>
                    <div className="description-item">
                        <dt>Program.</dt>
                        <dd>Book & Magagine</dd>
                    </div>
                    <div className="description-item">
                        <dt>Location.</dt>
                        <dd>Seoul</dd>
                    </div>
                </dl>
            </header>

            <Slider className="list-media" {...settingsMedia}>
                <div className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></div>
                <div className="photo"><img src="/assets/images/@temp/@project_02@2x.jpg" alt=""/></div>
                <div className="photo"><img src="/assets/images/@temp/@project_03@2x.jpg" alt=""/></div>
                <div className="photo"><img src="/assets/images/@temp/@project_04@2x.jpg" alt=""/></div>
            </Slider>
        </article>
    );
}

export default ProjectDetailContainer;
